import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { StatusPill } from "@/components/shared/Common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ADMIN } from "@/constants/testIds";
import { Building2, Check, X } from "lucide-react";

export default function AdminCompanies() {
  const [all, setAll] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/admin/all-companies"); setAll(data || []); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const decide = async (uid, approved) => {
    try {
      await api.post(`/admin/approve-user/${uid}`, { approved });
      toast.success(approved ? "Approved" : "Rejected");
      await load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const groups = { pending: [], approved: [], rejected: [] };
  all.forEach((u) => { (groups[u.status] || groups.pending).push(u); });

  const Row = ({ u }) => (
    <div className="card-flat p-4 flex flex-wrap gap-3 justify-between items-center" data-testid={`co-row-${u.secusource_id}`}>
      <div>
        <div className="flex items-center gap-2">
          <span className="ss-id">{u.secusource_id}</span>
          <StatusPill status={u.status} />
        </div>
        <div className="font-outfit font-semibold text-white mt-1">{u.company_name}</div>
        <div className="text-sm text-white/60 font-manrope">Contact: {u.contact_name} · {u.location} · {u.company_type}</div>
        <div className="text-xs text-white/50 font-mono">{u.email} · {u.phone}</div>
      </div>
      {u.status === "pending" && (
        <div className="flex gap-2">
          <Button onClick={() => decide(u.id, true)} className="bg-gold-500 hover:bg-gold-600 text-white" data-testid={`${ADMIN.approveBtn}-co-${u.secusource_id}`}>
            <Check className="w-4 h-4 mr-1" /> Approve
          </Button>
          <Button onClick={() => decide(u.id, false)} variant="outline" className="border-red-500 text-red-600 hover:bg-red-50">
            <X className="w-4 h-4 mr-1" /> Reject
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-outfit font-bold text-white flex items-center gap-2"><Building2 className="w-7 h-7 text-brand" /> Companies</h1>
      <Tabs defaultValue="pending">
        <TabsList>
          <TabsTrigger value="pending" data-testid="tab-pending-co">Pending ({groups.pending.length})</TabsTrigger>
          <TabsTrigger value="approved" data-testid="tab-approved-co">Approved ({groups.approved.length})</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="tab-rejected-co">Rejected ({groups.rejected.length})</TabsTrigger>
        </TabsList>
        {["pending","approved","rejected"].map((k) => (
          <TabsContent key={k} value={k} className="space-y-3 mt-4">
            {groups[k].length === 0 && <div className="text-white/60 font-manrope">Nothing here.</div>}
            {groups[k].map((u) => <Row key={u.id} u={u} />)}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
